import React from "react";
import { Controller } from "react-hook-form";
import { RadioGroup, FormControlLabel, Radio, FormLabel, FormHelperText, Checkbox } from "@mui/material";

const RadioButtonController = ({ name, isDisabled=false, isLabel=false, label, control, options, isRow=false,
   errors,  isMargin=true }) => {

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {isLabel && <FormLabel component="legend" sx={{ fontSize: "14px", minWidth:"120px", color:(theme)=>theme.palette.black.main}}>{label} :</FormLabel>}
            <RadioGroup {...field} row={isRow} sx={{ flexGrow: 1}}>
              {options.map((option, index) => (
                <FormControlLabel
                  sx={{ marginRight: !isMargin ? "0px" : undefined, "& .MuiFormControlLabel-label.Mui-disabled":{
                                        color:(theme)=>theme.palette.black.main,
                                    },
                                     "&.MuiFormControlLabel-root>span":{
                    fontSize:"14px",
                  }}}
                  key={index}
                  disabled={isDisabled}
                  value={option.value}
                  control={<Radio size="small" sx={{ padding: "0rem 4px",
                      "&.Mui-disabled": {
                        color: (theme)=>theme.palette.primary.main,
                      },
                    }} />}
                  label={option.label}
                />
              ))}
            </RadioGroup>
            {errors[name] && <FormHelperText error>{errors[name].message}</FormHelperText>}
          </>
        )}
      />
    </>
  );
};

export default RadioButtonController;


export const CheckBoxLikeRadio = ({ name, isDisabled=false, isLabel=false, label, control, options, isRow=false, errors, handleChange })=> {
  return(
    <>
      {options.map((option,index) => (
        <Controller
          key={index}
          name={name}
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                    handleChange(options, option.value);
                  }}
                />
              }
              label={option.label}
            />
          )}
        />
      ))}
        </>
  )
}
